import React from 'react';
export function AboutSection() {
  return <section id="ueber-uns" className="w-full py-20 px-6 md:px-12 bg-gray-50" data-id="element-51">
      <div className="max-w-5xl mx-auto" data-id="element-52">
        <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8 text-center" data-id="element-53">
          Herzlich willkommen!
        </h1>
        <div className="text-lg text-gray-600 leading-relaxed space-y-8" data-id="element-54">
          <p data-id="element-55">
            Wir – Dr. Angelika Sturny und Eva Sophie Schifferer,
            Diplom-Psychologinnen – begleiten Menschen in Phasen der
            Veränderung, Klärung und persönlicher Weiterentwicklung.
          </p>
          <p data-id="element-56">
            Vielleicht beschäftigen Sie derzeit akute Belastungen, offene Fragen
            oder der Wunsch nach neuer Orientierung. In unserer Praxis mit den
            Standorten Frankfurt am Main und München finden Sie einen
            geschützten Rahmen, um Klarheit zu gewinnen, Lösungen zu entwickeln
            und neue Perspektiven einzunehmen.
          </p>
          <p data-id="element-57">
            Unser Angebot umfasst psychologische Einzelberatung, Coaching,
            Psychotherapie nach dem Heilpraktikergesetz sowie Paarberatung und
            Familientherapie – wissenschaftlich fundiert, mit langjähriger
            Erfahrung und einem klaren Blick für das Wesentliche.
          </p>
        </div>
      </div>
    </section>;
}